module.exports = __webpack_public_path__ + "static/img/11.cd72906.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/zh/11.png
// module id = g3VU
// module chunks = 0